module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dDWOOE/tc-custom/9781460315682.jpg?1720118250033",
      "alt": "This image is the cover for the book Lady Risks All, Ladies of Impropriety"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lady Risks All, Ladies of Impropriety\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("Seducing the Captain")])]), _c('br'), _c('br'), _vm._v("It would be unwise to mistake me for an innocent debutante—for years I have graced the smoky gloom of many a billiards club and honed my skills at my father's side."), _c('br'), _c('br'), _vm._v("But now he has a new protégé—Captain Greer Barrington—and while my father would see me attract the attentions of an eligible lord I, Mercedes Lockhart, have other ambitions.… Even if that means seducing the captain to earn back my father's favor! I know I must avoid falling for Greer's charming smile…but his sensual kisses could be worth the risk.…"), _c('br'), _c('br'), _c('b', [_vm._v("From Harlequin Historical: "), _c('i', [_vm._v("Your romantic escape to the past.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bronwyn Scott\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Bronwyn Scott is the author of over 50 books. Her 2018 novella, \"Dancing with the Duke's Heir\" was a RITA finalist. She loves history and is always looking forward to the next story. She also enjoys talking with other writers and readers about books they like and the writing process. Readers can visit her at her Facebook page at Bronwynwrites and at her blog at http://www.bronwynswriting.blogspot.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0